import Vue from 'vue'
import VueRouter from 'vue-router'
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'dashboard' } },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/views/dashboard/Dashboard.vue'),
      meta: {
        pageTitle: 'Dashboard',
        breadcrumb: [
          {
            text: 'Dashboard',
            active: true,
          },
        ],
      },
    },
    {
      path: '/pharmaciens',
      name: 'pharmaciens',
      component: () => import('@/views/pharmaciens/pharmaciens.vue'),
      meta: {
        pageTitle: 'Pharmaciens',
        breadcrumb: [
          {
            text: 'Pharmaciens',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sponsors',
      name: 'sponsors',
      component: () => import('@/views/sponsors/sponsors.vue'),
      meta: {
        pageTitle: 'Sponsors',
        breadcrumb: [
          {
            text: 'Sponsors',
            active: true,
          },
        ],
      },
    },
    {
      path: '/configuration',
      name: 'configuration',
      component: () => import('@/views/pharmaciens/configuration.vue'),
      meta: {
        pageTitle: 'Configuration',
        breadcrumb: [
          {
            text: 'Configuration',
            active: true,
          },
        ],
      },
    },
    {
      path: '/participants',
      name: 'participants',
      component: () => import('@/views/participants-forum/participants.vue'),
      meta: {
        pageTitle: 'Participants',
        breadcrumb: [
          {
            text: 'Participants',
            active: true,
          },
        ],
      },
    },
    {
      path: '/articles/list',
      name: 'articles-list',
      component: () => import('@/views/articles/list/list.vue'),
      meta: {
        pageTitle: 'Liste d\'articles',
        breadcrumb: [
          {
            text: 'Liste d\'articles',
            active: true,
          },
        ],
      },
    },
    {
      path: '/articles/ajout',
      name: 'articles-ajout',
      component: () => import('@/views/articles/ajout/ajout.vue'),
      meta: {
        pageTitle: 'Ajouter un article',
        breadcrumb: [
          {
            text: 'Ajouter un article',
            active: true,
          },
        ],
      },
    },
    {
      path: '/articles/edit',
      name: 'articles-edit',
      component: () => import('@/views/articles/ajout/edit.vue'),
      meta: {
        pageTitle: 'Editer un article',
        breadcrumb: [
          {
            text: 'Editer un article',
            active: true,
          },
        ],
      },
    },
    {
      path: '/transactions-view',
      name: 'transactions-view',
      component: () => import('@/views/dashboard/Transaction.vue'),
      meta: {
        pageTitle: 'Transactions details',
        breadcrumb: [
          {
            text: 'Transactions details',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/forgot-password',
      name: 'auth-forgot-password-v2',
      component: () => import('@/views/ForgotPassword-v2.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/password-reset',
      name: 'password-reset',
      component: () => import('@/views/PasswordReset.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})


// router.beforeEach((to, _, next) => {
//   const isLoggedIn = isUserLoggedIn()
//   console.log('isLoggedIn', isLoggedIn)
//   if (isLoggedIn) {
//      next(getHomeRouteForLoggedInUser(''))
//   }
//   // if (!canNavigate(to)) {
//   //   // Redirect to login if not logged in
//   //   if (!isLoggedIn) return next({ name: 'login' })
//   //   // If logged in => not authorized
//   //   return next({ name: 'misc-not-authorized' })
//   // }
//   // Redirect if logged in
//   // if (to.meta.redirectIfLoggedIn && isLoggedIn) {
//   //   const userData = getUserData()
//   //   next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
//   // }

//   return next()
// })


// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
